import config from './config';

// Kept in step with the www-anon helper of the same name, which drives the invite landing
const mobileAppStores = (language) => {
  const badgeLang = (language || 'en').toLowerCase().startsWith('fr') ? 'fr' : 'en';

  return [
    {
      key: 'android',
      label: 'Google Play',
      url: config.app.stores.android,
      badge: `/images/svg/stores/android/android badge ${badgeLang}.svg`,
    },
    {
      key: 'ios',
      label: 'App Store',
      url: config.app.stores.ios,
      badge: `/images/svg/stores/iOS/iOS badge ${badgeLang} blk.svg`,
    },
  ];
};

export default mobileAppStores;
